import * as emoji from 'node-emoji';

/**
 * Converts emojis in text to their text descriptions for TTS
 * Example: "🍰" becomes "Cake"
 * @param text - The text containing emojis
 * @returns Text with emojis replaced by their descriptions
 */
export function convertEmojisToText(
  text?: string | null
): string | null | undefined {
  if (!text) return text;

  // Use node-emoji to replace emojis with their names
  // The 'unemojify' method converts emojis to :name: format
  // We then clean it up to be more readable for TTS
  let result = emoji.unemojify(text);

  // Replace :emoji_name: format with readable text
  // Remove colons and replace underscores with spaces
  result = result.replace(/:([^:]+):/g, (_match: string, emojiName: string) => {
    // Convert emoji_name to readable format
    const readable = emojiName
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
    return ` ${readable} `;
  });

  // Clean up extra spaces
  result = result.replace(/\s+/g, ' ').trim();

  return result;
}
